import candidateImage from './../Images/candidate-app.png'

export const educationEngineerTextList = [
  "Identify, formulate and solve problems.",
  "Conceive, design and develop projects (software solutions, components, products or processes) in different fields of application.",
  "Manage, plan, execute and control IT projects (software solutions, components, products or processes)",
  "Effectively use application techniques and tools.",
  "Contribute to the generation of technological developments and/or technological innovations.",
  "Perform effectively in work teams and in interdisciplinary exchange and production spaces.",
  "Communicate effectively.",
  "Act with ethics, professional responsibility and social commitment, considering the economic, social and environmental impact of their activity in the local and global context.",
  "Learn continuously and autonomously.",
  "Act with an entrepreneurial spirit.",
];

export const educationAnalyticTextList = [
  "Conceive, design and develop computer projects in small companies (software solutions, components, products)",
  "Use effectively the application techniques and tools in computing.",
  "Collaborate with the Computer Engineer in the generation of technological developments and/or technological innovations.",
  "Perform effectively in work teams.",
  "Act with ethics, professional responsibility and social commitment, considering the economic, social and environmental impact of their activity in the local and global context.",
  "Learn continuously and autonomously.",
];

export const skillsFE = [
  {
    name: "HTML5/CSS3",
    width: { width: "100%" },
    delay: 200,
    years: 10,
  },
  {
    name: "JavaScript",
    width: { width: "100%" },
    delay: 400,
    years: 10,
  },
  {
    name: "Angular",
    width: { width: "90%" },
    delay: 600,
    years: 4,
  },
  {
    name: "ReactJs",
    width: { width: "90%" },
    delay: 800,
    years: 4,
  },
  {
    name: "Typescript",
    width: { width: "90%" },
    delay: 1000,
    years: 4,
  },
  {
    name: "NextJS",
    width: { width: "85%" },
    delay: 1200,
    years: 3,
  },
  {
    name: "AngularJs",
    width: { width: "80%" },
    delay: 1400,
    years: 5,
  },
  {
    name: "JQuery",
    width: { width: "70%" },
    delay: 1600,
    years: 5,
  },
  {
    name: "Bootstrap",
    width: { width: "80%" },
    delay: 1800,
    years: 5,
  },
  {
    name: "Tailwind",
    width: { width: "80%" },
    delay: 2000,
    years: 3,
  },
  {
    name: "Redux",
    width: { width: "50%" },
    delay: 2200,
    years: 2,
  },
  {
    name: "Webpack",
    width: { width: "50%" },
    delay: 2400,
    years: 2,
  },
];

export const skillsBE = [
  {
    name: "NodeJs",
    width: { width: "80%" },
    delay: 200,
    years: 3,
  },
  {
    name: "ASP.NET C#",
    width: { width: "90%" },
    delay: 400,
    years: 8,
  },
  {
    name: "Sanity CMS",
    width: { width: "80%" },
    delay: 600,
    years: 2,
  },
  {
    name: "Sharepoint",
    width: { width: "80%" },
    delay: 800,
    years: 5,
  },
  {
    name: "Microservices",
    width: { width: "70%" },
    delay: 1000,
    years: 7,
  },
  {
    name: "Docker",
    width: { width: "70%" },
    delay: 1200,
    years: 3,
  },
  {
    name: "Express",
    width: { width: "70%" },
    delay: 1400,
    years: 2,
  },
  {
    name: "PHP",
    width: { width: "40%" },
    delay: 1600,
    years: 1,
  },
  {
    name: "Solidity",
    width: { width: "20%" },
    delay: 1800,
    years: 1,
  },
];

export const skillsDB = [
  {
    name: "MongoDb",
    width: { width: "80%" },
    delay: 200,
    years: 2,
  },
  {
    name: "SQL Server",
    width: { width: "80%" },
    delay: 400,
    years: 5,
  },
  {
    name: "PostgreSQL",
    width: { width: "70%" },
    delay: 600,
    years: 2,
  },
  {
    name: "RabbitMQ",
    width: { width: "70%" },
    delay: 800,
    years: 2,
  },
  {
    name: "MySQL",
    width: { width: "40%" },
    delay: 1000,
    years: 1,
  },
  {
    name: "Oracle",
    width: { width: "40%" },
    delay: 1200,
    years: 1,
  },
];

export const jobHistory = [
  {
    position: "Full-stack Developer",
    company: "Zaelot, EEUU",
    date: "February, 2024 - Present",
    description:
      "At Zaelot, I’ve been working as a full-stack developer since February 2024. My first project was for the largest gym franchise in the United States, where I contributed to the development and maintenance of internal applications using Angular for the frontend, .NET for the backend, and an IBM database system for data management.\n" +
      "In my second project, I joined the team of a major U.S. news channel to develop their modern web platform. I’ve been building responsive and dynamic pages using Next.js 15 and managing content and data structures through Sanity CMS. The main goal of the project is to deliver a fast, accessible, and user-friendly experience for readers, with a highly customizable and scalable architecture for editors and content creators.\n" +
      "My responsibilities include the development of new features, improvements to the existing codebase, component design, performance optimization, API integration, and writing tests. I also take part in code reviews, planning meetings, and demo presentations.",
    skillsUsed: [
      "NextJs",
      "Sanity CMS",
      "Angular",
      "HTML5/CSS3",
      "Javascript",
      "PostgreSQL",
      "Typescript",
      "Tailwind",
      "Bootstrap",
      "C#",
      "ASP.NET CORE",
      "Github",
      "Jira",
    ],
  },
  {
    position: "Full-stack Developer",
    company: "Mediafly, EEUU",
    date: "August, 2022 - February 2024",
    description:
      "At Mediafly I worked in the Intelligence360 team, a solution that allows its clients to optimize their sales process, " +
      "improve pipeline health, and increase their income through analysis and information provided. In short, it allows " +
      "clients to integrate external management systems (such as Salesforce, Bullhorn, Google, HubSpot, among others) to " +
      "the Intelligence360 system and perform centralized management to understand the performance in real time, predict " +
      "their forecast with confidence, and help in decision making.\n" +
      "As a full-stack developer at Mediafly, among my tasks were the expansion and creation of components and " +
      "functionalities on the Intelligence360 web using ReactJs, and the expansion and creation of new integrations " +
      "using NodeJs. This process included requirements analysis, API research, architecture design (entity mapping), " +
      "layout, unit and comprehensive tests.\n" +
      "Other of my tasks were code review, participation in analysis meetings, presentation of demos, and service monitoring.",
    skillsUsed: [
      "NodeJs",
      "ReactJs",
      "Bootstrap",
      "Jest",
      "Axios",
      "Sinon",
      "Mocha",
      "Lodash",
      "Docker",
      "Nock",
      "DevContainer",
      "Github",
      "Datadog",
      "Jira",
    ],
  },
  {
    position: "Full-stack Developer",
    company: "Kapsch Trafficom S.A. , Argentina",
    date: "February/2018 - August/2022",
    description:
      "Kapsch has a Legacy system for toll collection management with everything that it entails (transaction management, " +
      "vehicles, users, payments, fines, among others). The company participates in tenders in different countries/states " +
      "for the implementation of its system.\n" +
      "I worked in the Delivery team, in charge of adapting the Legacy system to the laws, requirements and business " +
      "rules of the country/state that was going to implement it.\n" +
      "As a full-stack developer at Kapsch, I worked with a range of technologies and methodologies to develop high-quality " +
      "software solutions for a variety of clients. My primary focus was on front-end development of responsive and engaging " +
      "user interfaces that integrated seamlessly with our back-end using AngularJS, but there were also components developed " +
      "in Angular and ReactJs integrated into the main solution using Webpack.\nI also worked extensively on the back-end, " +
      "programming in C# using .NET Framework 4.7.2 and .NET Core. " +
      "The principal design pattern used was Microservices architecture, using an API Gateway to administrate requests to " +
      "each microservice or responding a complex transaction by consulting several microservices to build a response.\n" +
      "The Database used was Microsoft SQL Server 17 and NHibernate to map it to the backend.",
    skillsUsed: [
      "AngularJs",
      "Angular",
      "ReactJs",
      "Webpack",
      "HTML5/CSS3",
      "C#",
      "ASP.NET CORE",
      "SignalR",
      "RabbitMQ",
      "Docker",
      "Microsoft SQL Server",
      "Github",
      "Jira",
      "Agile",
      "NGINX",
    ],
  },
  {
    position: "Full-stack Developer",
    company: "MS Technologies, Argentina",
    date: "October/2014 - February/2018",
    description:
      "MS Technologies had many clients from different sectors (automotive sales, banks, spare parts sales, " +
      "agricultural machinery sales, among others) to whom it provided solutions using Sharepoint as the main " +
      "framework to build e-commerces, audit management systems, workflow management, to name a few.\n" +
      "As a full-stack developer, I utilized my skills in .NET, javascript, and web " +
      "development to design and implement robust, user-friendly software for their clients.\n" +
      "Specifically, I was responsible for:\n" +
      " - Developing and maintaining Sharepoint web applications using .NET and Angular.js, ensuring high" +
      "performance and reliability.\n" +
      " - Connecting SharePoint to Angular.js and other web technologies to provide seamless integration " +
      "with existing software systems.\n" +
      " - Creating intuitive user interfaces using Angular.js, Bootstrap, CSS3, and HTML5, resulting " +
      "in improved user experience and engagement.\n" +
      " - Troubleshooting and resolving technical issues as they arose, using my knowledge of .NET and javascript.\n" +
      " - Collaborating with cross-functional teams to ensure successful delivery of projects on time " +
      "and within budget.\n" +
      " - Providing guidance and mentorship to junior developers, contributing to the growth and " +
      "success of the development team.\n" +
      "Overall, my work at MS Technologies allowed me to hone my skills as a full-stack developer and " +
      "provided me with invaluable experience in building scalable, high-quality software solutions.",
    skillsUsed: [
      "AngularJs",
      "Javascript",
      "JQuery",
      "Bootstrap",
      "HTML5/CSS3",
      "C#",
      "ASP.NET Framework",
      "Microsoft SQL Server",
      "Sharepoint 2017/Online",
    ],
  },
  {
    position: "QA/QC",
    company: "EFISAT Security and Logistics, Argentina",
    date: "April/2013 - January/2014",
    description:
      "Responsibilities and Functions:\n" +
      " - Responsible for application testing, both for internal use and for customers.\n" +
      " - Create tasks and bugs. Follow-up and corroboration of the resolution of the found bugs.\n" +
      " - Test case development.",
    skillsUsed: ["TFS"],
  },
  {
    position: "IT Responsible",
    company: "'Open' minimarkets franchise, Argentina",
    date: "March/2009 - June/2011",
    description:
      "Responsibilities and Functions:\n" +
      " - Anti-virus and firewall maintenance.\n" +
      " - Control of outgoing and incoming packages in the network.\n" +
      " - Database administration.\n" +
      " - Responsible for the maintenance and correct operation of the system databases of the network.\n",
    skillsUsed: ["Microsoft SQL Server"],
  },
];

export const aboutData = {
  description:
    "Hello! I'm Nicolás Logosettis, a motivated and results-driven Computer Engineer " +
    "with a passion for problem solving and a deep love for seeing tangible outcomes " +
    "from my work. With a keen eye for detail and a strong technical background, " +
    "I thrive on overcoming challenges and delivering innovative solutions. " +
    "My professional journey has been characterized by a constant drive for growth " +
    "and development, consistently seeking to expand my skill set and incorporate " +
    "the latest knowledge and technologies into my work.",
  hobbies: "Among my hobbies are music, sports and traveling!",
};

export const portfolioProjects = [
  {
    name: "Candidates Management App",
    image: candidateImage,
    techStack: [
      { icon: 'https://drive.google.com/uc?export=view&id=10dFGMwMcqC7aSvv0Oy2al7BRPZdmQobA' }
    ]
  }
]
